import { render, staticRenderFns } from "./DownloadFromRCBS.vue?vue&type=template&id=35279632&scoped=true&"
import script from "./DownloadFromRCBS.vue?vue&type=script&lang=js&"
export * from "./DownloadFromRCBS.vue?vue&type=script&lang=js&"
import style0 from "./DownloadFromRCBS.vue?vue&type=style&index=0&id=35279632&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35279632",
  null
  
)

export default component.exports